import type { Collection } from 'typings/utils';

export const strictValues: <T>(obj: Collection<T>) => readonly T[] = Object.values;
